import * as React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import GreenArrow from "../Icons/GreenArrow";
import GreenPlanet from "./GreenPlanet";
const useStyles = makeStyles(({
  palette,
  breakpoints,
  typography
}) => ({
  container: {
    display: "flex",
    alignItems: "flex-start"
  },
  arrow: {
    [breakpoints.down("sm")]: {
      height: typography.pxToRem(35)
    },
    width: typography.pxToRem(41),
    height: typography.pxToRem(51),
    fill: "none"
  },
  withArrowPlanet: {
    [breakpoints.down("sm")]: {
      marginTop: typography.pxToRem(15)
    },
    marginTop: typography.pxToRem(30),
    width: typography.pxToRem(32),
    height: typography.pxToRem(32)
  },
  withArrowText: {
    [breakpoints.down("sm")]: {
      marginTop: typography.pxToRem(15),
      fontSize: typography.pxToRem(13),
      maxWidth: "unset"
    },
    fontSize: typography.pxToRem(16),
    marginTop: typography.pxToRem(30),
    maxWidth: typography.pxToRem(150)
  }
}));

const GreenPlanetWithArrow = ({
  className
}) => {
  const styles = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.container, className)
  }, /*#__PURE__*/React.createElement(GreenArrow, {
    className: styles.arrow
  }), /*#__PURE__*/React.createElement(GreenPlanet, {
    iconClassName: styles.withArrowPlanet,
    textClassName: styles.withArrowText
  }));
};

export default GreenPlanetWithArrow;